var _circle, _circle2, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEqFlatbed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 16,
    r: 2.5,
    stroke: "#3F3F3F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 16,
    r: 2.5,
    stroke: "#3F3F3F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.82929 15C7.69759 14.6274 7.49436 14.2885 7.23611 14H8.76389C8.50564 14.2885 8.30241 14.6274 8.17071 15H7.82929ZM13.8293 15C13.6976 14.6274 13.4944 14.2885 13.2361 14H23C23.2761 14 23.5 14.2239 23.5 14.5C23.5 14.7761 23.2761 15 23 15H13.8293ZM2.17071 15C2.30241 14.6274 2.50564 14.2885 2.76389 14H1.5C0.947715 14 0.5 14.4477 0.5 15V16C0.5 16.2761 0.723858 16.5 1 16.5C1.27614 16.5 1.5 16.2761 1.5 16V15H2.17071Z",
    fill: "#3F3F3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 15.5V12.5C1 11.9477 1.44772 11.5 2 11.5H22C22.5523 11.5 23 11.9477 23 12.5V14.5",
    stroke: "#3F3F3F",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 18.5C22.2761 18.5 22.5 18.2761 22.5 18C22.5 17.7239 22.2761 17.5 22 17.5V18.5ZM19 17.5C18.7239 17.5 18.5 17.7239 18.5 18C18.5 18.2761 18.7239 18.5 19 18.5V17.5ZM20.0882 15V18H21.0882V15H20.0882ZM20.5882 18.5H22V17.5H20.5882V18.5ZM20.5882 17.5H19V18.5H20.5882V17.5Z",
    fill: "#3F3F3F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEqFlatbed);
export default __webpack_public_path__ + "static/media/eq-flatbed.a874940f877a2a86e7566ade27d2afb5.svg";
export { ForwardRef as ReactComponent };